<template>
  <!--
      作者：Lz
      时间：2020-06-09
      描述：会员-余额管理-余额充值设置
  -->
  <div class="pb50">
    <el-form ref="form" size="small" :model="form" label-width="200px">
      <div class="common-form">基础配置</div>
      
      <el-form-item label="是否开启2+1模式">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
        <div>不可以则不再支持前端取消订单</div>
      </el-form-item>
      
      
      <el-form-item label="升级触发关系变动:" prop="trigger_grade_id">
        <el-select v-if="!loading" v-model="form.trigger_grade_id" placeholder="请选择会员等级" style="width: 350px;" clearable>
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
        <p class="gray">当有用户升级到该等级,触发2+1模式逻辑</p>
      </el-form-item>
      <el-form-item label="2+1模式下级等级:" prop="down_user_grade_id">
        <el-select v-if="!loading" v-model="form.down_user_grade_id" placeholder="请选择会员等级" style="width: 350px;" clearable>
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
        <p class="gray">2+1模式下级等级,文档例子中的创客,请选择创客等级</p>
      </el-form-item>
      <el-form-item label="父级等级:" prop="top_grade_id">
        <el-select v-if="!loading" v-model="form.top_grade_id" placeholder="请选择会员等级" style="width: 350px;" multiple clearable>
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
        <p class="gray">2+1模式条件成立,B用户推荐了C和D创客,则开始从B往上找相应的等级用户(此处选择),如果找到,则BCD三人都放在该用户之下</p>
      </el-form-item>

      <!-- 新增平级返佣开关 -->
      <el-form-item label="是否开启平级返佣">
        <el-radio-group v-model="form.is_peer_rebate">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
        <div class="gray">开启后，平级用户间的交易将触发返佣</div>
      </el-form-item>

      <!-- 新增返佣比例输入 -->
      <el-form-item label="平级返佣比例(%)" v-if="form.is_peer_rebate === 1" prop="rebate_rate">
        <el-input-number 
          v-model="form.rebate_rate" 
          :min="1" 
          :max="50" 
          :step="1" 
          style="width: 200px"
          placeholder="请输入1-50之间的整数">
        </el-input-number>
        <div class="gray">返佣比例范围为1%-50%</div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button :loading="loading" type="primary" size="small" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import UserApi from '@/api/user'
import _ from 'lodash'

export default {
  data() {
    return {
      form: {
        // 触发2+1模式等级
        trigger_grade_id: '',
        down_user_grade_id: '',
        top_grade_id: '',
        is_open:1,
         is_peer_rebate: 0, // 新增平级返佣开关
        rebate_rate: 10,   // 新增返佣比例
      },
      gradeList: [],
      loading: false,
    }
  },
  created() {
    /*获取数据*/
    this.getData()
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this
      self.loading = true
      UserApi.getGradeSettings({}).then(res => {
        if (res.data) {
          self.form = _.merge(self.form, res.data.gradeSettings)
          self.gradeList = res.data.gradeList
          self.$forceUpdate()
          self.loading = false
        }
      }).catch(error => {})
    },
    /*保存*/
    onSubmit() {
      let self = this
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          UserApi.setGradeSettings(self.form).then(data => {
            self.loading = false
            if (data.code == 1) {
              self.$message.success('恭喜你，保存成功')
              /*刷新页面*/
              self.getData()
            } else {
              self.loading = false
            }
          }).catch(error => {
            self.loading = false
          })
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/user/grade/part/Setting.vue